module.exports = __webpack_public_path__ + "img/photo1.744938d0.png";